/**
 * Reverses over-aggressive HTML entity encoding (e.g. from API sanitize middleware on JSON text fields).
 * Safe to run multiple times until stable.
 */
export function decodeHtmlEntities(value: string): string {
  if (typeof value !== 'string' || value.length === 0) return value;
  let s = value;
  for (let i = 0; i < 6; i++) {
    const next = s
      .replace(/&amp;(#[0-9]+|#x[0-9a-fA-F]+|[a-zA-Z]+);/gi, '&$1;')
      .replace(/&#x27;|&#39;|&apos;/gi, "'")
      .replace(/&#x2F;|&#47;|&sol;/gi, '/')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#(\d+);/g, (_, n: string) => {
        const code = parseInt(n, 10);
        return Number.isFinite(code) ? String.fromCharCode(code) : _;
      });
    if (next === s) break;
    s = next;
  }
  return s.replace(/&amp;/g, '&');
}

/** Recursively decode HTML entities in annexure/DPIA definition or response JSON trees. */
export function decodeHtmlEntitiesDeep<T>(value: T): T {
  if (typeof value === 'string') {
    return decodeHtmlEntities(value) as T;
  }
  if (Array.isArray(value)) {
    return value.map(item => decodeHtmlEntitiesDeep(item)) as T;
  }
  if (value !== null && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
      out[key] = decodeHtmlEntitiesDeep(child);
    }
    return out as T;
  }
  return value;
}
